import Circle from './focusOutlines/FocusOutlineCircle';
import BadgedCircle from './focusOutlines/FocusOutlineBadgedCircle';
import Square from './focusOutlines/FocusOutlineSquare';

export default {
  Circle,
  BadgedCircle,
  Square,
};
